module.exports = __webpack_public_path__ + "img/o-button.2d2d16f5.png";